import { Layouts } from "../constants/Constants";
import { UrlComponents } from "../constants/UrlConstants";

export const getLayout = () => {
  let hostname= window.location.hostname;
  if (hostname.includes(UrlComponents.DomainPartial.HOL) || hostname.includes(UrlComponents.DomainPartial.HOLCustom)) {
    return Layouts.HOL;
  }

  return Layouts.MOL;
};